<template>
    <div>
        <!-- 工具栏 -->
        <ul :class="[ disabled ? 'disable_nav' : '', 'nav'  ]">
            <li @click.stop="showResourcesManager = !showResourcesManager; searchInfo.visiable = false;" :class="{ 'active': showResourcesManager }" title="资源管理器"><i class="iconfont icontuceng"></i></li>
            <li class="separator"></li>
            <li @click.stop="toggleSelector" :class="{ 'active': enableSelector }" title="选择"><i class="iconfont iconxuanze"></i></li>
            <li @click.stop="toggleViewSetting" :class="{ 'active': showViewSetting }" title="主视角">
                <i class="iconfont iconmorenshijiao"></i>
                <div class="view_menu" v-show="showViewSetting">
                    <p @click.stop="setDefaultView">设置主视角</p>
                    <p @click.stop="getDefaultView">回到主视角</p>
                </div>
            </li>
            <li @click.stop="hideDropMenu(); focusObject();" title="快速聚焦"><i class="iconfont iconAim"></i></li>
            <li @click.stop="toggleSearch" :class="{ 'active': searchInfo.visiable }" title="地点搜索"><i class="iconfont icondidiansousuo"></i></li>
            <li @click.stop="toggleMeasure" :class="{ 'active': enableMeasure }" title="测量">
                <i class="iconfont iconceliang"></i>
                <div class="view_menu view_menu_1" v-show="showMeasureSetting">
                    <p @click.stop="changeMeasureMode('line')"> 距离测量</p>
                    <p @click.stop="changeMeasureMode('height')"> 高度测量</p>
                    <p @click.stop="changeMeasureMode('area')"> 面积测量</p>
                </div>
            </li>
            <li title="特效" @click.stop="hideDropMenu(); showEffect = true;" :class="{ active: showEffect }"><i class="iconfont iconmofa"></i></li>
            <li @click.stop="toggleFly" :class="{ 'active': showRoma }" title="漫游"><i class="iconfont iconfeihanglujing"></i></li>
            <!-- <li title="设置"><i class="iconfont iconshezhi1"></i></li> -->
            <li @click.stop="switchViewMode('2d')" v-if="viewMode == '3d'" title="垂直视角"><i class="iconfont iconfushishijiao"></i></li>
            <li @click.stop="switchViewMode('3d')" v-if="viewMode == '2d'" title="3D视角"><i class="iconfont icon3Dshijiao"></i></li>
            <li @click.stop="setBillboard" title="标注"><i class="iconfont iconbiaozhu"></i></li>
            <!-- <li @click.stop="setHotspot" :class="{ 'active': activeHotSpot}" title="热点"><i class="iconfont iconredian"></i></li> -->
            <li class="separator"></li>
            <li @click.stop="combine" title="组合"><i class="iconfont iconfenzu"></i></li>
            <li @click.stop="explode" title="解组"><i class="iconfont iconjiechufenzu"></i></li>
            <!-- <li title="对齐" :class="selectedNum == 1 ? 'enable' : 'disable'"><i class="iconfont iconduiqi"></i></li> -->
            <li title="复制" @click.stop="copy"><i class="iconfont iconfuzhi1"></i></li>
            <li title="镜像" @click.stop="showMirrorConfig">
                <i class="iconfont iconjingxiang_duoge"></i>
                <div class="view_menu view_menu_1" v-show="showMirror">
                    <p @click.stop="mirror('x')">沿YZ平面</p>
                    <p @click.stop="mirror('y')">沿XZ平面</p>
                    <p @click.stop="mirror('z')">沿XY平面</p>
                </div>
            </li>
            <!-- <li title="拆分" :class="selectedNum == 1 ? 'enable' : 'disable'"><i class="iconfont iconchaifen"></i></li> -->
        </ul>

        <!-- 地址搜索 -->
        <div class="search_box" :style="{ left: searchInfo.visiable ? '30px' : '-350px' }">
            <el-autocomplete ref="autocomplete" class="inline-input" popper-class="my-autocomplete" v-model="searchInfo.searchInput" :fetch-suggestions="querySearchAsync" :trigger-on-focus="true" placeholder="地点搜索" @select="handleSelect">
                <i class="el-icon-search el-input__icon" slot="suffix" @click.stop="$refs.autocomplete.focus()"></i>
            </el-autocomplete>
            <el-button @click.stop="exitSearch" type="text">退出</el-button>
        </div>

        <!-- 资源管理器 -->
        <resource-manager :visible="showResourcesManager" @hide="showResourcesManager = !showResourcesManager;"></resource-manager>

        <!-- 标注 -->
        <billboard ref="billboard" v-if="readyScene"></billboard>

        <!-- 热点 -->
        <billboard2 ref="hotspot" v-if="readyScene && activeHotSpot"></billboard2>

        <!-- 特效设置 -->
        <effect @close="showEffect = false" v-if="showEffect"></effect>

        <!-- 漫游 -->
        <roma v-if="showRoma" :flyData="flyData" @exit="showRoma = false"></roma>
    </div>
</template>

<script>
import ResourceManager from './ResourcesManager.vue'
import Billboard from './Billboard.vue'
import Billboard2 from './Billboard2.vue'
import Effect from './Effect.vue'
import Roma from './Roma.vue'
import BusEvent from '@/busEvent'
import uuid from 'uuidjs'

var mapMeasure,
    billBoard,
    mapPin

export default {

    components: {
        ResourceManager,
        Billboard,
        Billboard2,
        Effect,
        Roma
    },

    props: {
        measureData: {
            default: []
        },
        flyData: {
            default: []
        }
    },

    data() {
        return {
            disabled: true,
            readyScene: false,
            enableSelector: false,
            enableMeasure: false,
            transformMode: false,
            searchInfo: {
                searchInput: '',
                visiable: false
            },
            showViewSetting: false,
            showMeasureSetting: false,
            showFlySetting: false,
            viewMode: '3d',
            measureChanged: false,
            showResourcesManager: false,
            selectedNum: 0,
            activeHotSpot: false,
            showMirror: false,
            showEffect: false,
            showRoma: false,
            disableKeyboard: false
        }
    },

    computed: {
        viewer(){
            return window.viewer
        }
    },

    watch: {
        enableSelector( val ){
            if( !val ){
                this.viewer.transform.setTarget( false )
            }
        },

        showViewSetting( val ){
            if( val && this.searchInfo.visiable ){
                this.searchInfo.visiable = false
            }
        },

        'searchInfo.visiable': function( val ){
            if( val && this.showViewSetting ){
                this.showViewSetting = false
            }
        },

        measureData( val ){
            mapMeasure.setData( val )
        },

        showRoma( val ){
            this.disableKeyboard = val
        }
    },

    mounted(){
        this.init()
    },

    beforeDestroy(){
        document.removeEventListener( 'keydown', this.deleteHandler )
        this.viewer.container.removeEventListener( 'mousedown', this.clickHandler )
    },

    methods: {
        init(){
            this.$bus.$on( BusEvent.ToolDisabledChange, status => this.disabled = status )
            this.$bus.$on( BusEvent.ToolChange, this.onButtonChange.bind(this) )
            this.$bus.$on( BusEvent.SelectedChange, this.onSelectedChange.bind(this) )
            this.$bus.$on( BusEvent.MapLoaded, () => this.readyScene = true )

            //监听键盘删除/查找键
            this.deleteHandler = this.keydownHandler.bind(this)
            document.addEventListener( 'keydown', this.deleteHandler )

            mapMeasure = new AMRT.MapMeasure( this.viewer )
            //选中测量路径删除
            mapMeasure.onSelect = selected => {
                this.measureChanged = true
                mapMeasure.remove( selected )
            }
            //测量绘制完成
            mapMeasure.onCompleteDraw = () => {
                this.measureChanged = true
                this.$bus.$emit( BusEvent.ToolDisabledChange, false )
                this.$bus.$emit( BusEvent.MenuDisbaledChange, false )
            }
            //绘制开始
            mapMeasure.onStartDraw = () => {
                this.$bus.$emit( BusEvent.ToolDisabledChange, true )
                this.$bus.$emit( BusEvent.MenuDisbaledChange, true )
            }
        },

        /**
         * 选中模型事件
         */
        onSelectedChange(){
            if( this.viewer.selectedObject.length === 1 ){
                this.enableSelector = true
                this.viewer.transform.setTarget( this.viewer.selectedObject[0] )
                this.viewer.transform.setMode( 'translate' )
                this.selectedNum = 1
                this.showResourcesManager = true
            }else{
               this.viewer.transform.setTarget( null ) 
               this.selectedNum = 0
            }
        },

        /**
         * 菜单切换重置功能
         */
        onButtonChange(){
            this.hideDropMenu()
            this.viewer.selectedObject = []
            this.viewer.enablePointSelector = false

            if( this.measureChanged ){
                this.$emit('measureChange', mapMeasure.data)
                this.measureChanged = false
            }

            if( this.enableSelector ){
                this.enableSelector = false
                this.viewer.transform.setTarget( false )
            }

            if( this._setHotSpotHandler ){
                this.viewer.container.removeEventListener( 'dblclick', this._setHotSpotHandler )
                this._setHotSpotHandler = null
            }
        },

        hideDropMenu(){
            this.activeHotSpot = false
            this.showResourcesManager = false
            this.showMirror = false
            this.searchInfo.visiable = false
            this.showEffect = false
            this.showViewSetting = false

            if( this.enableMeasure ){
                mapMeasure.clear()
                mapMeasure.enable = false
                this.enableMeasure = false
                this.showMeasureSetting = false
            }

            this.showRoma = false
        },

        /**
         * 菜单切换到选择模式
         */
        toggleSelector(){
            this.$bus.$emit( BusEvent.ToolChange )
            this.enableSelector = true
            this.viewer.enableTransform = true
            this.viewer.transform.setTarget( null )
            this.viewer.transform.setMode( 'translate' )
            this.viewer.enablePointSelector = true
            this.viewer.pointSelectorHandler = this.onSelectedHandler.bind(this)
        },

        onSelectedHandler( intersect ){
            this.$bus.$emit( BusEvent.SelectedChange )
            this.selectedNum = this.viewer.selectedObject.length
            if( !intersect || this.selectedNum != 1 ){
                this.viewer.transform.setTarget( null )
                return
            }
            this.showResourcesManager = true
        },

        /**
         * 删除模型
         */
        deleteModel(){
            this.viewer.transform.setTarget( null )
            let selectedObjects = this.viewer.selectedObject, billBoard = window.billBoard
            if( Array.isArray( selectedObjects ) && selectedObjects.length > 0 ){
                selectedObjects.map(obj => {
                    if( obj.isGroup ){
                        obj.traverse( mesh => {
                            if( mesh.mid ){
                                let arr = []
                                billBoard.group.children.map(item => {
                                    item.userData.mid == mesh.mid && arr.push(item)
                                })
                                billBoard.group.remove(...arr)
                            }
                        })
                    }else{
                        if( obj.mid ){
                            let arr = []
                            billBoard.group.children.map(item => {
                                item.userData.mid == obj.mid && arr.push(item)
                            })
                            billBoard.group.remove(...arr)
                        }
                    }
                    this.viewer.gisGroup.remove( obj )
                    this.$bus.$emit( BusEvent.SceneChange )
                })

            }
            this.viewer.selectedObject = []
            this.transformMode = false
            this.$bus.$emit( BusEvent.SelectedChange )
        },

        /**
         * 键盘删除
         */
        keydownHandler(e){
            if( this.disableKeyboard ) return
            if( e.key == 'Delete' ){
                let _this = this
                if( this.viewer.selectedObject.length > 0 ){
                    _this.$mr_confirm('确认删除该模型吗?', () => {
                        this.deleteModel()
                    })
                }else{
                    this.$message.info('请选中模型')
                }
            }
            if( e.key == 'f' || e.key == 'F' ){
                this.focusObject()
            }
        },

        /**
         * 设置默认视角
         */
        setDefaultView(){
            this.$mr_confirm('是否设置当前视角为主视角？', () => {
                this.viewer.gisManager.defaultView = this.viewer.controls.getView()
                this.showViewSetting = false
                this.$message.success( '主视角重置成功' )
            }, () => {})
        },

        /**
         * 恢复默认视角
         */
        getDefaultView(){
            this.viewer.gisManager.flyTo().then(() => {
                this.$bus.$emit( BusEvent.CameraChange )
            })
            this.showViewSetting = false
        },

        /**
         * 循环聚焦
         */
        focusObject(){
            var m = this.viewer.selectedObject
            if( m.length > 0 ){
                this.viewer.controls.fit( m[0] )
            }else{
                // let group = this.viewer.modelGroup.children.filter( item => item.isSceneModel )
                // group = group.concat( this.viewer.modelGroup.children )
                // group = group.concat( this.viewer.gisGroup.children )
                let group = this.viewer.gisGroup.children
                if( this.focusIndex === undefined || this.focusIndex >= group.length ) this.focusIndex = 0
                if( group.length > 0 ) m = group[ this.focusIndex ]
                this.focusIndex ++
                if( m ){
                    this.viewer.controls.fit( m )
                    setTimeout(() => {
                        this.viewer.gisManager.cameraChangeHandler()
                        if( m.isLargeScene ) m.loader.detect()
                    }, 500)
                }else{
                    this.$message.info('场景中无物体')
                }
            }
        },

        toggleViewSetting(){
            this.$bus.$emit( BusEvent.ToolChange )
            this.showViewSetting = true 
            this.showMeasureSetting = false
        },

        /**
         * 开启/关闭测量
         */
        toggleMeasure(){
            if( !this.enableMeasure ){
                this.$bus.$emit( BusEvent.ToolChange )
                this.enableMeasure = true
                this.measureChanged = false
                if( mapMeasure.data.length > 0 ) mapMeasure.load( mapMeasure.data )
                //收起视角设置下拉框
                this.showViewSetting = false
            }
            this.showMeasureSetting = true
            mapMeasure.enable = false
            mapMeasure.init()
        },

        /**
         * 切换测量模式
         * @author xiaoliwang
         * @date 2021-03-23
         */
        changeMeasureMode( mode ){
            if( !mapMeasure ) return
            if( !mapMeasure.enable ) mapMeasure.enable = true
            mapMeasure.mode = mode
            this.showMeasureSetting = false
            if( this.enableMeasure ){
                this.$notify({
                    title: '提示',
                    type: 'success',
                    position: 'bottom-left',
                    message: '鼠标左键单击地图标记测量点，右键单击结束测量',
                    duration: 3000
                })
            }
        },

        /**
         * 显示搜索
         */
        toggleSearch(){
            if( this.searchInfo.visiable ) return
            this.$bus.$emit( BusEvent.ToolChange )
            this.searchInfo.visiable = true
        },
        
        /**
         * 退出搜索
         */
        exitSearch(){
            if( mapPin ) {
                this.viewer.map.entities.remove( mapPin )
                mapPin = false
            }
            this.searchInfo.visiable = false
            this.searchInfo.searchInput = ''
        },

        /**
         * 根据关键字搜索地址
         */
        querySearchAsync( keywords, cb ){
            this.searchInfo.searchInput = keywords
            //天地图接口
            this.axios.get(`https://api.tianditu.gov.cn/search?postStr={"keyWord":"${keywords}","level":"16","mapBound":"-180,-90,180,90","queryType":"1","count":"20","start":"0"}&type=query&tk=bb2690fd63474d83fd6351dd6d0b38b1`).then(res => {
                let data = []
                //行政区
                if( res.area ){
                    res.area.lonlat = res.area.lonlat.replace(',', ' ')
                    res.area.value = res.area.name
                    data.push( res.area )
                }
                //详细地址
                if( res.pois ){
                    res.pois.map( item => {
                        item.value = item.name
                        data.push( item )
                    })
                }
                cb(data)
            })
        },

        /**
         * 相机飞行到选中位置
         */
        handleSelect( e ){
            if( !e.lonlat ){
                this.$message.warning('获取不到该位置信息')
                return
            }
            const lonlat = e.lonlat.split(' ')
            this.viewer.map.camera.flyTo({
                destination: Cesium.Cartesian3.fromDegrees( lonlat[0], lonlat[1], 2000.0),
                complete: () => {
                    if( billBoard ){
                        billBoard.resetSize()
                    }
                    if( mapPin ) this.viewer.map.entities.remove( mapPin )
                    mapPin = this.viewer.map.entities.add({
                        position: Cesium.Cartesian3.fromDegrees( lonlat[0], lonlat[1] ),
                        billboard: {
                            image: require('@/assets/img/location_2.png'),
                            verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
                            width: 35,
                            height: 35,
                            heightReference: 100,
                            distanceDisplayCondition: 5000
                        }
                    })
                }
            })
        },

        /**
         * 点击飞行按钮
         */
        toggleFly(){
            if( !this.showRoma ){
                this.$bus.$emit( BusEvent.ToolChange )
                this.showRoma = true
            }
        },

        /**
         * 切换模式
         */
        switchViewMode( mode ){
            if( mode === '2d' ){
                this.viewer.map.camera.flyTo({
                    destination: viewer.map.camera.position,
                    orientation: {
                        heading: 0,
                        pitch: -Cesium.Math.PI_OVER_TWO,
                        roll: 0
                    },
                    complete: () => {
                        this.$bus.$emit( BusEvent.CameraChange )
                    }
                })
            }
            if( mode === '3d' ){
                this.viewer.map.camera.flyTo({
                    destination: viewer.map.camera.position,
                    orientation: {
                        heading: 0,
                        pitch: -Cesium.Math.PI_OVER_FOUR,
                        roll: 0
                    },
                    complete: () => {
                        this.$bus.$emit( BusEvent.CameraChange )
                    }
                })
            }
            this.viewer.gisManager.setTiltEnable( mode === '3d' )
            this.viewMode = mode
        },

        /**
         * 分组
         */
        combine(){
            if( this.viewer.selectedObject.length > 1 ){
                this.$prompt('请输入组名', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputPattern: /^(.|\n){1,6}$/,
                    inputErrorMessage: '组名为1到6个字符组成',
                    closeOnClickModal: false,
                    closeOnPressEscape: false,
                    closeOnHashChange: false
                }).then(({ value }) => {
                    this.viewer.selectedObject = [ this.viewer.resourceManager.combine( this.viewer.selectedObject, value ) ]
                    this.$bus.$emit( BusEvent.SceneChange )
                }).catch()
            }else{
                this.$message.warning('请选中两个或以上模型（组）后进行该操作')
            }
        },

        /**
         * 拆分
         */
        explode(){
            if( this.viewer.selectedObject.length == 1 && this.viewer.selectedObject[0].isGroup ){
                let group = this.viewer.selectedObject[0]
                this.viewer.selectedObject = []
                this.viewer.transform.setTarget( null )
                this.viewer.resourceManager.explode( group )
                this.$bus.$emit( BusEvent.SceneChange )
            }else{
                this.$message.warning('请选中一个组后进行该操作')
            }
        },

        /**
         * 开启放置标注
         */
        setBillboard(){
            this.$notify({
                title: '提示',
                type: 'success',
                position: 'bottom-left',
                message: '单击模型任意位置，添加标注',
                duration: 3000
            })
            this.hideDropMenu()
            this.enableSelector = true
            this.viewer.enablePointSelector = true
            this.showResourcesManager = false
            this.viewer.transform.setTarget( null )
            this.viewer.selectedObject = []
            this.viewer.pointSelectorHandler = _selectedHandler.bind(this)
            // this.viewer.operator.disabledDrag = true
            function _selectedHandler( intersect, event ){
                // if( intersect == this.viewer.selectedObject[0] ){
                //     this.viewer.selectedObject = []
                //     this.$refs.billboard.init( event )
                // }
                this.$refs.billboard.init( event )
                // this.viewer.operator.disabledDrag = false
                this.viewer.pointSelectorHandler = this.onSelectedHandler.bind(this)
            }
        },

        /**
         * 开启放置热点
         */
        setHotspot(){
            if( this.activeHotSpot ){
                this.viewer.container.removeEventListener( 'dblclick', this._setHotSpotHandler )
                this._setHotSpotHandler = null
                this.activeHotSpot = false
                return
            }
            this.$bus.$emit( BusEvent.ToolChange )
            this.$notify({
                title: '提示',
                type: 'success',
                position: 'bottom-left',
                message: '双击模型任意位置添加热点',
                duration: 3000
            })
            this._setHotSpotHandler = _setHotSpot.bind(this)
            this.viewer.container.addEventListener( 'dblclick', this._setHotSpotHandler )
            this.activeHotSpot = true
            function _setHotSpot( event ){
                this.viewer.intersectModels(event, intersects => {
                    this.$refs.hotspot.init( intersects )
                }, this, this.viewer.gisGroup )
            }
        },
        /**
         * 复制模型
         */
        copy(){
            const selectedObject = this.viewer.selectedObject[0]
            if( !selectedObject ){
                this.$message.warning('请选中一个模型后进行该操作')
                return
            }
            if( !selectedObject.isSceneModel || selectedObject.isGroup ){
                this.$message.warning('仅支持单个模型复制')
                return 
            }
            var mesh = selectedObject.clone()
            mesh.mid = uuid.genV4().toString()
            mesh.modelName = selectedObject.modelName
            mesh.isSceneModel = true
            mesh.path = selectedObject.path
            mesh.obsParam = selectedObject.obsParam
            mesh.sourceId = selectedObject.sourceId
            selectedObject.parent.add( mesh )
            viewer.selectedObject = [ mesh ]
            viewer.transform.setTarget( mesh )
            this.$message.success( '复制模型成功' )
            this.$bus.$emit( BusEvent.SceneChange )
            this.selectedNum = 1

            let size = new AMRT.Box3().setFromObject( mesh ).getSize()
            mesh.position.copy(mesh.parent.worldToLocal(mesh.localToWorld(new AMRT.Vector3(size.x / mesh.scale.x,0,0))))
        },

        showMirrorConfig(){
            if( this.selectedNum === 1 ){
                let _showMirror = this.showMirror
                this.hideDropMenu()
                this.showMirror = !_showMirror
            }else{
                this.$message.warning('请选中一个模型后进行该操作')
            }
        },

        /**
         * 镜像模型
         */
        mirror( axis ){
            this.showMirror = false
            const selectedObject = this.viewer.selectedObject[0]
            if( !selectedObject ){
                this.$message.warning('请选中一个模型后进行该操作')
                return
            }
            if( !selectedObject.isSceneModel || selectedObject.isGroup ){
                this.$message.warning('仅支持单个模型镜像操作')
                return 
            }
            var mesh = selectedObject.clone()
            mesh.mid = uuid.genV4().toString()
            mesh.modelName = selectedObject.modelName
            mesh.isSceneModel = true
            mesh.path = selectedObject.path
            mesh.obsParam = selectedObject.obsParam
            mesh.sourceId = selectedObject.sourceId
            switch (axis) {
                case 'x':
                    mesh.scale.x = -mesh.scale.x
                    break;
                case 'y':
                    mesh.scale.y = -mesh.scale.y
                    break;
                case 'z':
                    mesh.scale.z = -mesh.scale.z
                    break;
                default:
                    break;
            }
            selectedObject.parent.add( mesh )
            viewer.selectedObject = [ mesh ]
            viewer.transform.setTarget( mesh )
            this.$message.success( '模型镜像成功' )
            this.$bus.$emit( BusEvent.SceneChange )
            this.selectedNum = 1
        }
    }
}

</script>

<style lang="scss" scoped> @import './style.scss';

</style>
<style lang="scss">
.my-autocomplete{ couter-reset: count -1; counter-increment: count 0; width:350px !important; left: 30px !important; }
.my-autocomplete li{line-height: 44px !important;}
.my-autocomplete [role=option]::before{ 
    content: counter(count); font-size: 10px; counter-increment: count; display: inline-block; width: 24px; height: 30px; line-height: 30px; position: relative; top: -2px; background: url('~@/assets/img/location.png'); background-repeat: no-repeat; background-position: center; color: #FFF; text-align: center; margin-right: 5px;    background-size: contain;
}
.my-autocomplete li:hover{
    &::before{ 
        content: counter(count); counter-increment: count; display: inline-block; width: 24px; height: 30px; line-height: 30px; position: relative; top: -2px; background: url('~@/assets/img/location_1.png'); background-repeat: no-repeat; background-position: center; color: #FFF; text-align: center; margin-right: 5px;    background-size: contain;
    }
}
</style>